/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum PagesDisplayPersistenceOption {
  CARDS = "CARDS",
  COMPACT_LIST = "COMPACT_LIST",
  LIST = "LIST",
}

//==============================================================
// END Enums and Input Objects
//==============================================================

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: HomeViewsUserPreferencesQuery
// ====================================================

export interface HomeViewsUserPreferencesQuery_userPreferences {
  homePagesDisplayView: PagesDisplayPersistenceOption;
}

export interface HomeViewsUserPreferencesQuery {
  userPreferences: HomeViewsUserPreferencesQuery_userPreferences;
}
